export type AppPhoneCountryCode = string;

export type AppPhoneCountry = {
  code: AppPhoneCountryCode;
  label: string;
  dialCode: string;
  localPrefix: string;
  flagSrc: string;
};

const flagSrc = (code: string) =>
  `https://flagcdn.com/w40/${code.toLowerCase()}.png`;

const ALL_COUNTRIES: AppPhoneCountry[] = [
  {
    code: "AF",
    label: "Afghanistan",
    dialCode: "93",
    localPrefix: "0",
    flagSrc: flagSrc("AF"),
  },
  {
    code: "AL",
    label: "Albania",
    dialCode: "355",
    localPrefix: "0",
    flagSrc: flagSrc("AL"),
  },
  {
    code: "DZ",
    label: "Algeria",
    dialCode: "213",
    localPrefix: "0",
    flagSrc: flagSrc("DZ"),
  },
  {
    code: "AD",
    label: "Andorra",
    dialCode: "376",
    localPrefix: "0",
    flagSrc: flagSrc("AD"),
  },
  {
    code: "AO",
    label: "Angola",
    dialCode: "244",
    localPrefix: "0",
    flagSrc: flagSrc("AO"),
  },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("AG"),
  },
  {
    code: "AR",
    label: "Argentina",
    dialCode: "54",
    localPrefix: "0",
    flagSrc: flagSrc("AR"),
  },
  {
    code: "AM",
    label: "Armenia",
    dialCode: "374",
    localPrefix: "0",
    flagSrc: flagSrc("AM"),
  },
  {
    code: "AU",
    label: "Australia",
    dialCode: "61",
    localPrefix: "0",
    flagSrc: flagSrc("AU"),
  },
  {
    code: "AT",
    label: "Austria",
    dialCode: "43",
    localPrefix: "0",
    flagSrc: flagSrc("AT"),
  },
  {
    code: "AZ",
    label: "Azerbaijan",
    dialCode: "994",
    localPrefix: "0",
    flagSrc: flagSrc("AZ"),
  },
  {
    code: "BS",
    label: "Bahamas",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("BS"),
  },
  {
    code: "BH",
    label: "Bahrain",
    dialCode: "973",
    localPrefix: "0",
    flagSrc: flagSrc("BH"),
  },
  {
    code: "BD",
    label: "Bangladesh",
    dialCode: "880",
    localPrefix: "0",
    flagSrc: flagSrc("BD"),
  },
  {
    code: "BB",
    label: "Barbados",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("BB"),
  },
  {
    code: "BY",
    label: "Belarus",
    dialCode: "375",
    localPrefix: "0",
    flagSrc: flagSrc("BY"),
  },
  {
    code: "BE",
    label: "Belgium",
    dialCode: "32",
    localPrefix: "0",
    flagSrc: flagSrc("BE"),
  },
  {
    code: "BZ",
    label: "Belize",
    dialCode: "501",
    localPrefix: "0",
    flagSrc: flagSrc("BZ"),
  },
  {
    code: "BJ",
    label: "Benin",
    dialCode: "229",
    localPrefix: "0",
    flagSrc: flagSrc("BJ"),
  },
  {
    code: "BT",
    label: "Bhutan",
    dialCode: "975",
    localPrefix: "0",
    flagSrc: flagSrc("BT"),
  },
  {
    code: "BO",
    label: "Bolivia",
    dialCode: "591",
    localPrefix: "0",
    flagSrc: flagSrc("BO"),
  },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    dialCode: "387",
    localPrefix: "0",
    flagSrc: flagSrc("BA"),
  },
  {
    code: "BW",
    label: "Botswana",
    dialCode: "267",
    localPrefix: "0",
    flagSrc: flagSrc("BW"),
  },
  {
    code: "BR",
    label: "Brazil",
    dialCode: "55",
    localPrefix: "0",
    flagSrc: flagSrc("BR"),
  },
  {
    code: "BN",
    label: "Brunei",
    dialCode: "673",
    localPrefix: "0",
    flagSrc: flagSrc("BN"),
  },
  {
    code: "BG",
    label: "Bulgaria",
    dialCode: "359",
    localPrefix: "0",
    flagSrc: flagSrc("BG"),
  },
  {
    code: "BF",
    label: "Burkina Faso",
    dialCode: "226",
    localPrefix: "0",
    flagSrc: flagSrc("BF"),
  },
  {
    code: "BI",
    label: "Burundi",
    dialCode: "257",
    localPrefix: "0",
    flagSrc: flagSrc("BI"),
  },
  {
    code: "CV",
    label: "Cabo Verde",
    dialCode: "238",
    localPrefix: "0",
    flagSrc: flagSrc("CV"),
  },
  {
    code: "KH",
    label: "Cambodia",
    dialCode: "855",
    localPrefix: "0",
    flagSrc: flagSrc("KH"),
  },
  {
    code: "CM",
    label: "Cameroon",
    dialCode: "237",
    localPrefix: "0",
    flagSrc: flagSrc("CM"),
  },
  {
    code: "CA",
    label: "Canada",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("CA"),
  },
  {
    code: "CF",
    label: "Central African Republic",
    dialCode: "236",
    localPrefix: "0",
    flagSrc: flagSrc("CF"),
  },
  {
    code: "TD",
    label: "Chad",
    dialCode: "235",
    localPrefix: "0",
    flagSrc: flagSrc("TD"),
  },
  {
    code: "CL",
    label: "Chile",
    dialCode: "56",
    localPrefix: "0",
    flagSrc: flagSrc("CL"),
  },
  {
    code: "CN",
    label: "China",
    dialCode: "86",
    localPrefix: "0",
    flagSrc: flagSrc("CN"),
  },
  {
    code: "CO",
    label: "Colombia",
    dialCode: "57",
    localPrefix: "0",
    flagSrc: flagSrc("CO"),
  },
  {
    code: "KM",
    label: "Comoros",
    dialCode: "269",
    localPrefix: "0",
    flagSrc: flagSrc("KM"),
  },
  {
    code: "CG",
    label: "Congo",
    dialCode: "242",
    localPrefix: "0",
    flagSrc: flagSrc("CG"),
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    dialCode: "243",
    localPrefix: "0",
    flagSrc: flagSrc("CD"),
  },
  {
    code: "CR",
    label: "Costa Rica",
    dialCode: "506",
    localPrefix: "0",
    flagSrc: flagSrc("CR"),
  },
  {
    code: "CI",
    label: "Côte d'Ivoire",
    dialCode: "225",
    localPrefix: "0",
    flagSrc: flagSrc("CI"),
  },
  {
    code: "HR",
    label: "Croatia",
    dialCode: "385",
    localPrefix: "0",
    flagSrc: flagSrc("HR"),
  },
  {
    code: "CU",
    label: "Cuba",
    dialCode: "53",
    localPrefix: "0",
    flagSrc: flagSrc("CU"),
  },
  {
    code: "CY",
    label: "Cyprus",
    dialCode: "357",
    localPrefix: "0",
    flagSrc: flagSrc("CY"),
  },
  {
    code: "CZ",
    label: "Czech Republic",
    dialCode: "420",
    localPrefix: "0",
    flagSrc: flagSrc("CZ"),
  },
  {
    code: "DK",
    label: "Denmark",
    dialCode: "45",
    localPrefix: "0",
    flagSrc: flagSrc("DK"),
  },
  {
    code: "DJ",
    label: "Djibouti",
    dialCode: "253",
    localPrefix: "0",
    flagSrc: flagSrc("DJ"),
  },
  {
    code: "DM",
    label: "Dominica",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("DM"),
  },
  {
    code: "DO",
    label: "Dominican Republic",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("DO"),
  },
  {
    code: "EC",
    label: "Ecuador",
    dialCode: "593",
    localPrefix: "0",
    flagSrc: flagSrc("EC"),
  },
  {
    code: "EG",
    label: "Egypt",
    dialCode: "20",
    localPrefix: "0",
    flagSrc: flagSrc("EG"),
  },
  {
    code: "SV",
    label: "El Salvador",
    dialCode: "503",
    localPrefix: "0",
    flagSrc: flagSrc("SV"),
  },
  {
    code: "GQ",
    label: "Equatorial Guinea",
    dialCode: "240",
    localPrefix: "0",
    flagSrc: flagSrc("GQ"),
  },
  {
    code: "ER",
    label: "Eritrea",
    dialCode: "291",
    localPrefix: "0",
    flagSrc: flagSrc("ER"),
  },
  {
    code: "EE",
    label: "Estonia",
    dialCode: "372",
    localPrefix: "0",
    flagSrc: flagSrc("EE"),
  },
  {
    code: "SZ",
    label: "Eswatini",
    dialCode: "268",
    localPrefix: "0",
    flagSrc: flagSrc("SZ"),
  },
  {
    code: "ET",
    label: "Ethiopia",
    dialCode: "251",
    localPrefix: "0",
    flagSrc: flagSrc("ET"),
  },
  {
    code: "FJ",
    label: "Fiji",
    dialCode: "679",
    localPrefix: "0",
    flagSrc: flagSrc("FJ"),
  },
  {
    code: "FI",
    label: "Finland",
    dialCode: "358",
    localPrefix: "0",
    flagSrc: flagSrc("FI"),
  },
  {
    code: "FR",
    label: "France",
    dialCode: "33",
    localPrefix: "0",
    flagSrc: flagSrc("FR"),
  },
  {
    code: "GA",
    label: "Gabon",
    dialCode: "241",
    localPrefix: "0",
    flagSrc: flagSrc("GA"),
  },
  {
    code: "GM",
    label: "Gambia",
    dialCode: "220",
    localPrefix: "0",
    flagSrc: flagSrc("GM"),
  },
  {
    code: "GE",
    label: "Georgia",
    dialCode: "995",
    localPrefix: "0",
    flagSrc: flagSrc("GE"),
  },
  {
    code: "DE",
    label: "Germany",
    dialCode: "49",
    localPrefix: "0",
    flagSrc: flagSrc("DE"),
  },
  {
    code: "GH",
    label: "Ghana",
    dialCode: "233",
    localPrefix: "0",
    flagSrc: flagSrc("GH"),
  },
  {
    code: "GR",
    label: "Greece",
    dialCode: "30",
    localPrefix: "0",
    flagSrc: flagSrc("GR"),
  },
  {
    code: "GD",
    label: "Grenada",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("GD"),
  },
  {
    code: "GT",
    label: "Guatemala",
    dialCode: "502",
    localPrefix: "0",
    flagSrc: flagSrc("GT"),
  },
  {
    code: "GN",
    label: "Guinea",
    dialCode: "224",
    localPrefix: "0",
    flagSrc: flagSrc("GN"),
  },
  {
    code: "GW",
    label: "Guinea-Bissau",
    dialCode: "245",
    localPrefix: "0",
    flagSrc: flagSrc("GW"),
  },
  {
    code: "GY",
    label: "Guyana",
    dialCode: "592",
    localPrefix: "0",
    flagSrc: flagSrc("GY"),
  },
  {
    code: "HT",
    label: "Haiti",
    dialCode: "509",
    localPrefix: "0",
    flagSrc: flagSrc("HT"),
  },
  {
    code: "HN",
    label: "Honduras",
    dialCode: "504",
    localPrefix: "0",
    flagSrc: flagSrc("HN"),
  },
  {
    code: "HU",
    label: "Hungary",
    dialCode: "36",
    localPrefix: "0",
    flagSrc: flagSrc("HU"),
  },
  {
    code: "IS",
    label: "Iceland",
    dialCode: "354",
    localPrefix: "0",
    flagSrc: flagSrc("IS"),
  },
  {
    code: "IN",
    label: "India",
    dialCode: "91",
    localPrefix: "0",
    flagSrc: flagSrc("IN"),
  },
  {
    code: "ID",
    label: "Indonesia",
    dialCode: "62",
    localPrefix: "0",
    flagSrc: flagSrc("ID"),
  },
  {
    code: "IR",
    label: "Iran",
    dialCode: "98",
    localPrefix: "0",
    flagSrc: flagSrc("IR"),
  },
  {
    code: "IQ",
    label: "Iraq",
    dialCode: "964",
    localPrefix: "0",
    flagSrc: flagSrc("IQ"),
  },
  {
    code: "IE",
    label: "Ireland",
    dialCode: "353",
    localPrefix: "0",
    flagSrc: flagSrc("IE"),
  },
  {
    code: "IL",
    label: "Israel",
    dialCode: "972",
    localPrefix: "0",
    flagSrc: flagSrc("IL"),
  },
  {
    code: "IT",
    label: "Italy",
    dialCode: "39",
    localPrefix: "0",
    flagSrc: flagSrc("IT"),
  },
  {
    code: "JM",
    label: "Jamaica",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("JM"),
  },
  {
    code: "JP",
    label: "Japan",
    dialCode: "81",
    localPrefix: "0",
    flagSrc: flagSrc("JP"),
  },
  {
    code: "JO",
    label: "Jordan",
    dialCode: "962",
    localPrefix: "0",
    flagSrc: flagSrc("JO"),
  },
  {
    code: "KZ",
    label: "Kazakhstan",
    dialCode: "7",
    localPrefix: "0",
    flagSrc: flagSrc("KZ"),
  },
  {
    code: "KE",
    label: "Kenya",
    dialCode: "254",
    localPrefix: "0",
    flagSrc: flagSrc("KE"),
  },
  {
    code: "KI",
    label: "Kiribati",
    dialCode: "686",
    localPrefix: "0",
    flagSrc: flagSrc("KI"),
  },
  {
    code: "KP",
    label: "Korea, North",
    dialCode: "850",
    localPrefix: "0",
    flagSrc: flagSrc("KP"),
  },
  {
    code: "KR",
    label: "Korea, South",
    dialCode: "82",
    localPrefix: "0",
    flagSrc: flagSrc("KR"),
  },
  {
    code: "KW",
    label: "Kuwait",
    dialCode: "965",
    localPrefix: "0",
    flagSrc: flagSrc("KW"),
  },
  {
    code: "KG",
    label: "Kyrgyzstan",
    dialCode: "996",
    localPrefix: "0",
    flagSrc: flagSrc("KG"),
  },
  {
    code: "LA",
    label: "Laos",
    dialCode: "856",
    localPrefix: "0",
    flagSrc: flagSrc("LA"),
  },
  {
    code: "LV",
    label: "Latvia",
    dialCode: "371",
    localPrefix: "0",
    flagSrc: flagSrc("LV"),
  },
  {
    code: "LB",
    label: "Lebanon",
    dialCode: "961",
    localPrefix: "0",
    flagSrc: flagSrc("LB"),
  },
  {
    code: "LS",
    label: "Lesotho",
    dialCode: "266",
    localPrefix: "0",
    flagSrc: flagSrc("LS"),
  },
  {
    code: "LR",
    label: "Liberia",
    dialCode: "231",
    localPrefix: "0",
    flagSrc: flagSrc("LR"),
  },
  {
    code: "LY",
    label: "Libya",
    dialCode: "218",
    localPrefix: "0",
    flagSrc: flagSrc("LY"),
  },
  {
    code: "LI",
    label: "Liechtenstein",
    dialCode: "423",
    localPrefix: "0",
    flagSrc: flagSrc("LI"),
  },
  {
    code: "LT",
    label: "Lithuania",
    dialCode: "370",
    localPrefix: "0",
    flagSrc: flagSrc("LT"),
  },
  {
    code: "LU",
    label: "Luxembourg",
    dialCode: "352",
    localPrefix: "0",
    flagSrc: flagSrc("LU"),
  },
  {
    code: "MG",
    label: "Madagascar",
    dialCode: "261",
    localPrefix: "0",
    flagSrc: flagSrc("MG"),
  },
  {
    code: "MW",
    label: "Malawi",
    dialCode: "265",
    localPrefix: "0",
    flagSrc: flagSrc("MW"),
  },
  {
    code: "MY",
    label: "Malaysia",
    dialCode: "60",
    localPrefix: "0",
    flagSrc: flagSrc("MY"),
  },
  {
    code: "MV",
    label: "Maldives",
    dialCode: "960",
    localPrefix: "0",
    flagSrc: flagSrc("MV"),
  },
  {
    code: "ML",
    label: "Mali",
    dialCode: "223",
    localPrefix: "0",
    flagSrc: flagSrc("ML"),
  },
  {
    code: "MT",
    label: "Malta",
    dialCode: "356",
    localPrefix: "0",
    flagSrc: flagSrc("MT"),
  },
  {
    code: "MH",
    label: "Marshall Islands",
    dialCode: "692",
    localPrefix: "0",
    flagSrc: flagSrc("MH"),
  },
  {
    code: "MR",
    label: "Mauritania",
    dialCode: "222",
    localPrefix: "0",
    flagSrc: flagSrc("MR"),
  },
  {
    code: "MU",
    label: "Mauritius",
    dialCode: "230",
    localPrefix: "0",
    flagSrc: flagSrc("MU"),
  },
  {
    code: "MX",
    label: "Mexico",
    dialCode: "52",
    localPrefix: "0",
    flagSrc: flagSrc("MX"),
  },
  {
    code: "FM",
    label: "Micronesia",
    dialCode: "691",
    localPrefix: "0",
    flagSrc: flagSrc("FM"),
  },
  {
    code: "MD",
    label: "Moldova",
    dialCode: "373",
    localPrefix: "0",
    flagSrc: flagSrc("MD"),
  },
  {
    code: "MC",
    label: "Monaco",
    dialCode: "377",
    localPrefix: "0",
    flagSrc: flagSrc("MC"),
  },
  {
    code: "MN",
    label: "Mongolia",
    dialCode: "976",
    localPrefix: "0",
    flagSrc: flagSrc("MN"),
  },
  {
    code: "ME",
    label: "Montenegro",
    dialCode: "382",
    localPrefix: "0",
    flagSrc: flagSrc("ME"),
  },
  {
    code: "MA",
    label: "Morocco",
    dialCode: "212",
    localPrefix: "0",
    flagSrc: flagSrc("MA"),
  },
  {
    code: "MZ",
    label: "Mozambique",
    dialCode: "258",
    localPrefix: "0",
    flagSrc: flagSrc("MZ"),
  },
  {
    code: "MM",
    label: "Myanmar",
    dialCode: "95",
    localPrefix: "0",
    flagSrc: flagSrc("MM"),
  },
  {
    code: "NA",
    label: "Namibia",
    dialCode: "264",
    localPrefix: "0",
    flagSrc: flagSrc("NA"),
  },
  {
    code: "NR",
    label: "Nauru",
    dialCode: "674",
    localPrefix: "0",
    flagSrc: flagSrc("NR"),
  },
  {
    code: "NP",
    label: "Nepal",
    dialCode: "977",
    localPrefix: "0",
    flagSrc: flagSrc("NP"),
  },
  {
    code: "NL",
    label: "Netherlands",
    dialCode: "31",
    localPrefix: "0",
    flagSrc: flagSrc("NL"),
  },
  {
    code: "NZ",
    label: "New Zealand",
    dialCode: "64",
    localPrefix: "0",
    flagSrc: flagSrc("NZ"),
  },
  {
    code: "NI",
    label: "Nicaragua",
    dialCode: "505",
    localPrefix: "0",
    flagSrc: flagSrc("NI"),
  },
  {
    code: "NE",
    label: "Niger",
    dialCode: "227",
    localPrefix: "0",
    flagSrc: flagSrc("NE"),
  },
  {
    code: "NG",
    label: "Nigeria",
    dialCode: "234",
    localPrefix: "0",
    flagSrc: flagSrc("NG"),
  },
  {
    code: "MK",
    label: "North Macedonia",
    dialCode: "389",
    localPrefix: "0",
    flagSrc: flagSrc("MK"),
  },
  {
    code: "NO",
    label: "Norway",
    dialCode: "47",
    localPrefix: "0",
    flagSrc: flagSrc("NO"),
  },
  {
    code: "OM",
    label: "Oman",
    dialCode: "968",
    localPrefix: "0",
    flagSrc: flagSrc("OM"),
  },
  {
    code: "PK",
    label: "Pakistan",
    dialCode: "92",
    localPrefix: "0",
    flagSrc: flagSrc("PK"),
  },
  {
    code: "PW",
    label: "Palau",
    dialCode: "680",
    localPrefix: "0",
    flagSrc: flagSrc("PW"),
  },
  {
    code: "PS",
    label: "Palestine",
    dialCode: "970",
    localPrefix: "0",
    flagSrc: flagSrc("PS"),
  },
  {
    code: "PA",
    label: "Panama",
    dialCode: "507",
    localPrefix: "0",
    flagSrc: flagSrc("PA"),
  },
  {
    code: "PG",
    label: "Papua New Guinea",
    dialCode: "675",
    localPrefix: "0",
    flagSrc: flagSrc("PG"),
  },
  {
    code: "PY",
    label: "Paraguay",
    dialCode: "595",
    localPrefix: "0",
    flagSrc: flagSrc("PY"),
  },
  {
    code: "PE",
    label: "Peru",
    dialCode: "51",
    localPrefix: "0",
    flagSrc: flagSrc("PE"),
  },
  {
    code: "PH",
    label: "Philippines",
    dialCode: "63",
    localPrefix: "0",
    flagSrc: flagSrc("PH"),
  },
  {
    code: "PL",
    label: "Poland",
    dialCode: "48",
    localPrefix: "0",
    flagSrc: flagSrc("PL"),
  },
  {
    code: "PT",
    label: "Portugal",
    dialCode: "351",
    localPrefix: "0",
    flagSrc: flagSrc("PT"),
  },
  {
    code: "QA",
    label: "Qatar",
    dialCode: "974",
    localPrefix: "0",
    flagSrc: flagSrc("QA"),
  },
  {
    code: "RO",
    label: "Romania",
    dialCode: "40",
    localPrefix: "0",
    flagSrc: flagSrc("RO"),
  },
  {
    code: "RU",
    label: "Russia",
    dialCode: "7",
    localPrefix: "0",
    flagSrc: flagSrc("RU"),
  },
  {
    code: "RW",
    label: "Rwanda",
    dialCode: "250",
    localPrefix: "0",
    flagSrc: flagSrc("RW"),
  },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("KN"),
  },
  {
    code: "LC",
    label: "Saint Lucia",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("LC"),
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("VC"),
  },
  {
    code: "WS",
    label: "Samoa",
    dialCode: "685",
    localPrefix: "0",
    flagSrc: flagSrc("WS"),
  },
  {
    code: "SM",
    label: "San Marino",
    dialCode: "378",
    localPrefix: "0",
    flagSrc: flagSrc("SM"),
  },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    dialCode: "239",
    localPrefix: "0",
    flagSrc: flagSrc("ST"),
  },
  {
    code: "SA",
    label: "Saudi Arabia",
    dialCode: "966",
    localPrefix: "0",
    flagSrc: flagSrc("SA"),
  },
  {
    code: "SN",
    label: "Senegal",
    dialCode: "221",
    localPrefix: "0",
    flagSrc: flagSrc("SN"),
  },
  {
    code: "RS",
    label: "Serbia",
    dialCode: "381",
    localPrefix: "0",
    flagSrc: flagSrc("RS"),
  },
  {
    code: "SC",
    label: "Seychelles",
    dialCode: "248",
    localPrefix: "0",
    flagSrc: flagSrc("SC"),
  },
  {
    code: "SL",
    label: "Sierra Leone",
    dialCode: "232",
    localPrefix: "0",
    flagSrc: flagSrc("SL"),
  },
  {
    code: "SG",
    label: "Singapore",
    dialCode: "65",
    localPrefix: "0",
    flagSrc: flagSrc("SG"),
  },
  {
    code: "SK",
    label: "Slovakia",
    dialCode: "421",
    localPrefix: "0",
    flagSrc: flagSrc("SK"),
  },
  {
    code: "SI",
    label: "Slovenia",
    dialCode: "386",
    localPrefix: "0",
    flagSrc: flagSrc("SI"),
  },
  {
    code: "SB",
    label: "Solomon Islands",
    dialCode: "677",
    localPrefix: "0",
    flagSrc: flagSrc("SB"),
  },
  {
    code: "SO",
    label: "Somalia",
    dialCode: "252",
    localPrefix: "0",
    flagSrc: flagSrc("SO"),
  },
  {
    code: "ZA",
    label: "South Africa",
    dialCode: "27",
    localPrefix: "0",
    flagSrc: flagSrc("ZA"),
  },
  {
    code: "SS",
    label: "South Sudan",
    dialCode: "211",
    localPrefix: "0",
    flagSrc: flagSrc("SS"),
  },
  {
    code: "ES",
    label: "Spain",
    dialCode: "34",
    localPrefix: "0",
    flagSrc: flagSrc("ES"),
  },
  {
    code: "LK",
    label: "Sri Lanka",
    dialCode: "94",
    localPrefix: "0",
    flagSrc: flagSrc("LK"),
  },
  {
    code: "SD",
    label: "Sudan",
    dialCode: "249",
    localPrefix: "0",
    flagSrc: flagSrc("SD"),
  },
  {
    code: "SR",
    label: "Suriname",
    dialCode: "597",
    localPrefix: "0",
    flagSrc: flagSrc("SR"),
  },
  {
    code: "SE",
    label: "Sweden",
    dialCode: "46",
    localPrefix: "0",
    flagSrc: flagSrc("SE"),
  },
  {
    code: "CH",
    label: "Switzerland",
    dialCode: "41",
    localPrefix: "0",
    flagSrc: flagSrc("CH"),
  },
  {
    code: "SY",
    label: "Syria",
    dialCode: "963",
    localPrefix: "0",
    flagSrc: flagSrc("SY"),
  },
  {
    code: "TW",
    label: "Taiwan",
    dialCode: "886",
    localPrefix: "0",
    flagSrc: flagSrc("TW"),
  },
  {
    code: "TJ",
    label: "Tajikistan",
    dialCode: "992",
    localPrefix: "0",
    flagSrc: flagSrc("TJ"),
  },
  {
    code: "TZ",
    label: "Tanzania",
    dialCode: "255",
    localPrefix: "0",
    flagSrc: flagSrc("TZ"),
  },
  {
    code: "TH",
    label: "Thailand",
    dialCode: "66",
    localPrefix: "0",
    flagSrc: flagSrc("TH"),
  },
  {
    code: "TL",
    label: "Timor-Leste",
    dialCode: "670",
    localPrefix: "0",
    flagSrc: flagSrc("TL"),
  },
  {
    code: "TG",
    label: "Togo",
    dialCode: "228",
    localPrefix: "0",
    flagSrc: flagSrc("TG"),
  },
  {
    code: "TO",
    label: "Tonga",
    dialCode: "676",
    localPrefix: "0",
    flagSrc: flagSrc("TO"),
  },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("TT"),
  },
  {
    code: "TN",
    label: "Tunisia",
    dialCode: "216",
    localPrefix: "0",
    flagSrc: flagSrc("TN"),
  },
  {
    code: "TR",
    label: "Turkey",
    dialCode: "90",
    localPrefix: "0",
    flagSrc: flagSrc("TR"),
  },
  {
    code: "TM",
    label: "Turkmenistan",
    dialCode: "993",
    localPrefix: "0",
    flagSrc: flagSrc("TM"),
  },
  {
    code: "TV",
    label: "Tuvalu",
    dialCode: "688",
    localPrefix: "0",
    flagSrc: flagSrc("TV"),
  },
  {
    code: "UG",
    label: "Uganda",
    dialCode: "256",
    localPrefix: "0",
    flagSrc: flagSrc("UG"),
  },
  {
    code: "UA",
    label: "Ukraine",
    dialCode: "380",
    localPrefix: "0",
    flagSrc: flagSrc("UA"),
  },
  {
    code: "AE",
    label: "United Arab Emirates",
    dialCode: "971",
    localPrefix: "0",
    flagSrc: flagSrc("AE"),
  },
  {
    code: "GB",
    label: "United Kingdom",
    dialCode: "44",
    localPrefix: "0",
    flagSrc: flagSrc("GB"),
  },
  {
    code: "US",
    label: "United States",
    dialCode: "1",
    localPrefix: "1",
    flagSrc: flagSrc("US"),
  },
  {
    code: "UY",
    label: "Uruguay",
    dialCode: "598",
    localPrefix: "0",
    flagSrc: flagSrc("UY"),
  },
  {
    code: "UZ",
    label: "Uzbekistan",
    dialCode: "998",
    localPrefix: "0",
    flagSrc: flagSrc("UZ"),
  },
  {
    code: "VU",
    label: "Vanuatu",
    dialCode: "678",
    localPrefix: "0",
    flagSrc: flagSrc("VU"),
  },
  {
    code: "VA",
    label: "Vatican City",
    dialCode: "39",
    localPrefix: "0",
    flagSrc: flagSrc("VA"),
  },
  {
    code: "VE",
    label: "Venezuela",
    dialCode: "58",
    localPrefix: "0",
    flagSrc: flagSrc("VE"),
  },
  {
    code: "VN",
    label: "Vietnam",
    dialCode: "84",
    localPrefix: "0",
    flagSrc: flagSrc("VN"),
  },
  {
    code: "YE",
    label: "Yemen",
    dialCode: "967",
    localPrefix: "0",
    flagSrc: flagSrc("YE"),
  },
  {
    code: "ZM",
    label: "Zambia",
    dialCode: "260",
    localPrefix: "0",
    flagSrc: flagSrc("ZM"),
  },
  {
    code: "ZW",
    label: "Zimbabwe",
    dialCode: "263",
    localPrefix: "0",
    flagSrc: flagSrc("ZW"),
  },
];

export const COUNTRY_OPTIONS: AppPhoneCountry[] = [
  ...ALL_COUNTRIES.filter((country) => country.code === "MW"),
  ...ALL_COUNTRIES.filter((country) => country.code === "ZA"),
  ...ALL_COUNTRIES.filter(
    (country) => !["MW", "ZA"].includes(country.code),
  ).sort((a, b) => a.label.localeCompare(b.label)),
];
